import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { API } from '../lib/api';
import axios from 'axios';
import { Clapperboard, Clock, CheckCircle2, XCircle, Eye, PlusCircle, ChevronRight } from 'lucide-react';

const ST = {
  pending: { label: 'En attente', icon: Clock, cl: 'bg-amber-950/30 border-amber-600/40 text-amber-300' },
  approved: { label: 'Publié', icon: CheckCircle2, cl: 'bg-emerald-950/30 border-emerald-600/40 text-emerald-300' },
  rejected: { label: 'Refusé', icon: XCircle, cl: 'bg-red-950/30 border-red-600/40 text-red-300' },
};

// Widget compact « Mes shorts » pour les tableaux de bord élève/enseignant
export default function MyShortsWidget({ basePath = '/eleve' }) {
  const [mine, setMine] = useState(null);
  useEffect(() => {
    const token = localStorage.getItem('cv_token');
    axios.get(`${API}/shorts/mine`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setMine(r.data))
      .catch(() => setMine([]));
  }, []);

  const m = mine || [];
  const c = {
    pending: m.filter((s) => s.status === 'pending').length,
    approved: m.filter((s) => s.status === 'approved').length,
    rejected: m.filter((s) => s.status === 'rejected').length,
  };

  return (
    <div className="rounded-2xl border border-sky-500/25 bg-gradient-to-br from-[#07131d] to-[#0d0d0e] p-5" data-testid="dash-shorts-widget">
      <div className="flex items-center justify-between gap-3 mb-3">
        <h3 className="font-serif-editorial text-white text-[18px] inline-flex items-center gap-2">
          <Clapperboard size={16} className="text-sky-400" /> Mes shorts
        </h3>
        <Link to={`${basePath}/mes-shorts`} data-testid="dash-shorts-all"
          className="inline-flex items-center gap-1 text-sky-300 hover:text-sky-200 text-[12px] font-semibold">
          Tout voir <ChevronRight size={13} />
        </Link>
      </div>

      <div className="grid grid-cols-3 gap-2 mb-3">
        {[
          { k: 'pending', ...ST.pending },
          { k: 'approved', ...ST.approved },
          { k: 'rejected', ...ST.rejected },
        ].map(({ k, label, icon: Icon, cl }) => (
          <Link key={k} to={`${basePath}/mes-shorts`} data-testid={`dash-shorts-count-${k}`}
            className={`rounded-xl border p-2.5 text-center transition hover:brightness-125 ${cl}`}>
            <div className="font-serif-editorial text-[22px] leading-none">{c[k]}</div>
            <div className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider mt-1 opacity-80"><Icon size={10} /> {label}</div>
          </Link>
        ))}
      </div>

      {mine === null ? (
        <div className="text-white/40 text-[12px]">Chargement…</div>
      ) : m.length === 0 ? (
        <p className="text-white/50 text-[12px] leading-snug">Partage ta première astuce vidéo à la communauté — validée par l'équipe avant publication.</p>
      ) : (
        <div className="space-y-1.5">
          {m.slice(0, 2).map((s) => {
            const st = ST[s.status] || ST.pending;
            const Icon = st.icon;
            return (
              <div key={s.id} className="flex items-center gap-2 rounded-xl bg-white/[0.03] border border-white/10 px-3 py-2" data-testid={`dash-shorts-item-${s.id}`}>
                <span className="text-white text-[12px] font-semibold truncate flex-1">{s.title}</span>
                {s.status === 'approved' && (
                  <span className="inline-flex items-center gap-1 text-white/55 text-[10.5px] font-bold shrink-0"><Eye size={10} /> {s.views || 0}</span>
                )}
                <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full border text-[9.5px] font-bold shrink-0 ${st.cl}`}>
                  <Icon size={9} /> {st.label}
                </span>
              </div>
            );
          })}
        </div>
      )}

      <Link to="/shorts/proposer" data-testid="dash-shorts-propose"
        className="mt-3 w-full h-10 rounded-full bg-gradient-to-r from-sky-500 to-sky-700 hover:from-sky-400 hover:to-sky-600 text-white text-[12.5px] font-bold inline-flex items-center justify-center gap-1.5 transition active:scale-95">
        <PlusCircle size={14} /> Proposer un short
      </Link>
    </div>
  );
}
